const getLocaleForZendesk = (lang) => {
	if (lang === "br") return "pt-BR";
	const map = { en: "en-US", tr: "tr-TR", ru: "ru-RU", es: "es-ES", it: "it-IT", pt: "pt-PT", fa: "fa-IR", th: "th-TH" };
	return map[lang] || "en-US";
};

/**
 * Opens Zendesk widget with a prefilled message template.
 * @param {Object} options
 * @param {string} options.subject - Prefilled subject line
 * @param {string} options.description - Prefilled description/message body
 * @param {string} [options.name] - User name for Zendesk identify
 * @param {string} [options.email] - User email for Zendesk identify
 * @param {string} [options.currentLanguage] - Locale for Zendesk (e.g. 'en', 'br')
 */
export const openZendeskWithPrefilledMessage = ({
	subject,
	description,
	name = "",
	email = "",
	currentLanguage = "en",
}) => {
	try {
		window?.zE?.identify?.({
			name,
			email,
		});
		window?.zE?.activate();

		window?.zE?.setLocale(getLocaleForZendesk(currentLanguage));

		let retries = 30;

		const interval = setInterval(() => {
			const widget = document.getElementById("webWidget");

			if (retries <= 0) {
				clearInterval(interval);
				console.warn("Zendesk widget not found after multiple attempts.");
				return;
			}

			if (widget) {
				try {
					const widgetTextfield = widget.contentDocument.querySelector("textarea");

					if (widgetTextfield) {
						const message = `Subject: ${subject}\n\nDescription: ${description}`;

						const nativeInputValueSetter = Object.getOwnPropertyDescriptor(
							window.HTMLTextAreaElement.prototype,
							"value"
						).set;
						nativeInputValueSetter.call(widgetTextfield, message);

						const inputEvent = new Event("input", { bubbles: true });
						widgetTextfield.dispatchEvent(inputEvent);

						widgetTextfield.focus();

						clearInterval(interval);
						return;
					}
				} catch (err) {
					console.warn("Error accessing widget iframe:", err);
				}
			}

			retries--;
		}, 400);
	} catch (error) {
		console.error("Zendesk open error:", error);
	}
};
